import { decodeJwtPayload } from 'utils/jwt';

import { getPreferredIdToken } from 'services/auth';

export type ResolvedEndUserAuth = {
  euId: string | null;
  idToken: string | null;
};

const getLocalStorageValue = (key: string): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  if (typeof window.localStorage?.getItem !== 'function') {
    return null;
  }

  return window.localStorage.getItem(key);
};

const getEuIdFromToken = (token: string | null): string | null => {
  if (!token) {
    return null;
  }

  const payload = decodeJwtPayload(token);
  return typeof payload?.['custom:eu_id'] === 'string' ? payload['custom:eu_id'] : null;
};

/** Prefer user-session Redux token over legacy auth slice fields. */
export const resolveEndUserAuth = (authState: {
  euId: string | null;
  idToken: string | null;
}): ResolvedEndUserAuth => {
  const nextIdToken = getPreferredIdToken() ?? authState.idToken;
  const euIdFromToken = getEuIdFromToken(nextIdToken ?? null);
  const nextEuId = euIdFromToken ?? getLocalStorageValue('euId') ?? authState.euId;

  return { euId: nextEuId, idToken: nextIdToken };
};
